export function stableStringify(value: unknown): string {
  const seen = new WeakSet<object>()

  const normalize = (v: unknown): unknown => {
    if (v === undefined) return null
    if (v === null) return null

    if (typeof v === 'number') {
      if (Number.isNaN(v)) return 'NaN'
      if (!Number.isFinite(v)) return v > 0 ? 'Infinity' : '-Infinity'
      return v
    }

    if (typeof v === 'function' || typeof v === 'symbol') {
      return String(v)
    }

    if (v instanceof Date) return v.toISOString()
    if (v instanceof RegExp) return v.toString()
    if (v instanceof Map) {
      return Object.fromEntries(Array.from(v.entries()).map(([key, val]) => [String(key), normalize(val)]))
    }
    if (v instanceof Set) {
      return Array.from(v.values()).map(normalize)
    }
    if (v instanceof Date) return v.toISOString()

    if (Array.isArray(v)) return v.map(normalize)

    if (typeof v === 'object') {
      if (seen.has(v)) return '[Circular]'
      seen.add(v)

      const out: Record<string, unknown> = {}

      const obj = v as Record<string, unknown>
      Object.keys(obj)
        .sort()
        .forEach(k => {
          out[k] = normalize(obj[k])
        })
      return out
    }

    return v
  }

  return JSON.stringify(normalize(value))
}

export function isDirty(current: unknown, snapshot: unknown): boolean {
  return stableStringify(current) !== stableStringify(snapshot)
}
